import { useContext } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { EmptyState } from '@cognite/cogs-core-v11/components/empty-state/empty-state.tsx';
import { LogoutIcon } from '@cognite/cogs-icons-v11/system-icons/LogoutIcon.tsx';
import { SettingsIcon } from '@cognite/cogs-icons-v11/system-icons/SettingsIcon.tsx';

import { PageContainerStyle } from '../../../pages/elements';

import { AppConfigErrorScreenContext } from './cdm-app-config-error-screen.context';
import * as S from './elements';

export const SETUP_GUIDE_LINK =
  'https://docs.cognite.com/cdf/deploy/cdf_toolkit/guides/set_up_infield';

export interface AppConfigErrorScreenProps {
  title: string;
  body: string;
}

export const AppConfigErrorScreen: FC<AppConfigErrorScreenProps> = ({
  title,
  body,
}) => {
  const { useInfieldLogout, useIsDesktop, useIsAppConfiguratorQuery } =
    useContext(AppConfigErrorScreenContext);

  const { t } = useTranslation('user');
  const { logout } = useInfieldLogout();
  const isDesktop = useIsDesktop();
  const { data: hasAppConfigPermission } = useIsAppConfiguratorQuery();

  const onClickGoToSetupLink = () => {
    window.open(SETUP_GUIDE_LINK, '_blank')?.focus();
  };

  return (
    <PageContainerStyle>
      <S.ErrorStateContainer>
        <EmptyState
          title={title}
          primaryAction={
            <Button type="ghost" icon={<LogoutIcon />} onClick={logout}>
              {t('USER_ERROR_LOCATION_MISSING_LOGOUT_BUTTON', 'Logout')}
            </Button>
          }
          description={body}
          secondaryAction={
            hasAppConfigPermission && isDesktop ? (
              <Button
                type="ghost"
                icon={<SettingsIcon />}
                onClick={onClickGoToSetupLink}
              >
                {t(
                  'USER_ERROR_LOCATION_MISSING_GOTO_SETUP_GUIDE_LINK_BUTTON',
                  'Go to InField setup guide'
                )}
              </Button>
            ) : null
          }
        />
      </S.ErrorStateContainer>
    </PageContainerStyle>
  );
};
